module.exports = __webpack_public_path__ + "media/images/noire-c1e0d193b6246710fc0d9cefc67fd359.png";